import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  searchActionCreator,
  clearFilterActionCreator,
  updateSelectedCategoryFiltersActionCreator,
} from '../redux/actions/DashboardActions';
import {
  getDashboardProps,
  getReportCategoryFilters,
  getFilteredReportCategories,
} from '../redux/selectors/DashboardSelectors';
// eslint-disable-next-line import/no-named-as-default
import ReportItemContainer from './ReportItemContainer';
import DashboardReportTypes from '../redux/actions/types/DashboardReportTypes';
import CheckboxTreeSelector from '../../common/components/CheckboxTreeSelector';
import Icons from '../../../core/modules/common/components/Icons';
import { compareReportCategoriesForReportMenu } from '../../react-table/helpers/utils';
import { getFailedReportsDefinitions } from '../../user/redux/selectors/UserReportSelectors';

export class DashboardAllReportsContainer extends Component {
  onCategorySelect = selected =>
    this.props.updateSelectedCategoryFiltersActionCreator(selected);

  searchInReports = e =>
    this.props.searchActionCreator(e.target.value);

  clearFilter = () =>
    this.props.clearFilterActionCreator();

  refreshPage = () => {
    window.location.reload(true);
  };

  render() {
    const {
      filteredReportCategories,
      reportCategoryFilters,
      dashboard: {
        keyword,
        selectedCategoryFilters,
      },
      failedReportsDefinitions,
    } = this.props;
    const activeClass = keyword ? 'active' : '';
    const foundClass = keyword && filteredReportCategories.length ? 'found' : '';
    const notFoundClass = keyword && filteredReportCategories.length === 0 ? 'not-found' : '';

    return (
      <div className="dashboard-content">
        <div className="dashboard-left">
          <CheckboxTreeSelector
            title="REPORT CATEGORIES"
            nodes={reportCategoryFilters}
            selected={selectedCategoryFilters}
            onSelect={this.onCategorySelect}
            expanded={reportCategoryFilters.map(group => group.value)}
            expandDisabled
          />
          {selectedCategoryFilters.length ? (
            <button type="button" className="btn btn-block btn-clear-filter" onClick={this.clearFilter}>
              <Icons.CrossIcon /> Clear Filter
            </button>
          ) : (
            <div className="btn-clear-filter">&nbsp;</div>
          )}
        </div>
        <div className="dashboard-right">
          <div className={`search-container ${activeClass} ${foundClass} ${notFoundClass}`}>
            <Icons.SearchIcon />
            <input
              className="text-input input-search"
              value={keyword}
              onChange={this.searchInReports}
              placeholder="Start typing to search in reports..."
            />
          </div>
          <div className="report-definitions">
            <h1 className={`no-result-msg ${filteredReportCategories.length ? 'hidden' : ''}`}>
              {/* eslint-disable-next-line no-nested-ternary */}
              <span>{!failedReportsDefinitions ? keyword.length !== 0 || filteredReportCategories.length === 0 ? 'No reports found: ' : 'Loading' : <button type="button" className="btn-link" onClick={this.refreshPage}>Report list could not be loaded. Please click here to try again</button>}</span>
              {!failedReportsDefinitions &&
                <button type="button" className="btn-link" onClick={this.clearFilter}>
                  Clear Filter
                </button>
              }
            </h1>
            <section className={`report-definitions__sections ${filteredReportCategories.length === 0 ? 'hidden' : ''}`}>
              {/* eslint-disable-next-line max-len */}
              {
                filteredReportCategories.sort((a, b) => compareReportCategoriesForReportMenu(a, b)) && filteredReportCategories.map(category => (
                  <section className="section" key={category.name}>
                    <div className="section-title">
                      <h5>{category.name}</h5>
                    </div>
                    <div className="reports">
                      {category.reports
                          .map((report, i) =>
                            (<ReportItemContainer
                              key={report.reportCode + i} // eslint-disable-line
                              type={DashboardReportTypes.ALL}
                              report={report}
                            />))}
                    </div>
                  </section>
                  ))}
            </section>
          </div>
        </div>
      </div>
    );
  }
}

DashboardAllReportsContainer.propTypes = {
  filteredReportCategories: PropTypes.arrayOf(PropTypes.shape),
  reportCategoryFilters: PropTypes.arrayOf(PropTypes.shape),
  dashboard: PropTypes.objectOf(PropTypes.shape),
  searchActionCreator: PropTypes.func,
  clearFilterActionCreator: PropTypes.func,
  updateSelectedCategoryFiltersActionCreator: PropTypes.func,
  failedReportsDefinitions: PropTypes.bool,
};

const mapDispatchToProps = dispatch => bindActionCreators({
  searchActionCreator,
  clearFilterActionCreator,
  updateSelectedCategoryFiltersActionCreator,
}, dispatch);

const mapStateToProps = state => ({
  dashboard: getDashboardProps(state),
  filteredReportCategories: getFilteredReportCategories(state),
  reportCategoryFilters: getReportCategoryFilters(state),
  failedReportsDefinitions: getFailedReportsDefinitions(state),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DashboardAllReportsContainer);

